/* unplugin-vue-components disabled */import script from "./sustainability-grid.vue?vue&type=script&lang=js"
export * from "./sustainability-grid.vue?vue&type=script&lang=js"

import "./sustainability-grid.vue?vue&type=style&index=0&id=1ce6b9fc&lang=scss"

const __exports__ = script;

export default __exports__